<template>
    <div class="app-layout__trial">
        <span class="app-layout__trial--period">{{ getTrialPeriodHeading }}</span>
        <common-button
            :isDisabled="!$auth.getUser()?.isMasterUser"
            :label="getButtonLabel"
            size="small"
            type="primary"
            @click="$auth.isUserPracticeDemo() ? goToSignup() : toggleBillingPricingModal()"
        ></common-button>
        <span class="app-layout__trial--period">{{ getTrialPeriodSubheading }}</span>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import PracticePlanEnum from '@/enums/PracticePlanEnum'

    export default {
        computed: {
            numberOfDaysLeft() {
                const today = dayjs()
                const trialPeriod = dayjs(this.$auth.getPractice().trialPeriodEnds)
                const diff = Math.ceil(trialPeriod.diff(today, 'day'))
                return diff
            },

            getButtonLabel() {
                if (this.$auth.isUserPracticeDemo()) {
                    return this.$t('pages.billing.billing.trial.finish_registration')
                }

                if (this.$auth.getPractice().subscription === PracticePlanEnum.TRIAL_PERIOD) {
                    return this.$t('pages.billing.billing.trial.go_billing')
                }

                return this.$t('pages.billing.billing.trial.upgrade')
            },

            getTrialPeriodSubheading() {
                if (this.$auth.getPractice().subscription === PracticePlanEnum.NETWORK) {
                    return this.$t('pages.billing.billing.trial.cotninue_recieving')
                }
                return ''
            },

            getTrialPeriodHeading() {
                if (this.$auth.isUserPracticeDemo()) {
                    return this.$t('pages.billing.billing.trial.demo_account')
                }
                const numberOfDays = this.numberOfDaysLeft
                if (this.$auth.getPractice().subscription === PracticePlanEnum.NETWORK) {
                    return this.$t('pages.billing.billing.trial.expired')
                } else {
                    return this.$tc('pages.billing.billing.trial.ending', numberOfDays, {
                        numberOfDays: numberOfDays,
                    })
                }
            },
        },

        methods: {
            toggleBillingPricingModal() {
                this.$emit('toggle-billing-pricing-modal')
            },

            goToSignup() {
                this.$emit('toggle-paywall-modal')
            },
        },
    }
</script>
